import { Color, DefaultValue, getDefaultTransition, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

interface OverlayProps {
  visible?: boolean
}

export const ModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: ${zIndex.Modal};
  pointer-events: none;
`

interface ModalProps {
  visible?: boolean
  width?: number
}

export const Modal = styled.div<ModalProps>`
  display: flex;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  flex-direction: column;
  width: ${({ width }) => (width ? `${width}px` : '576px')};
  max-height: 80vh;
  margin-top: -${Spacing.S24};
  border-radius: ${DefaultValue.BorderRadius};
  transform: ${({ visible }) => (visible ? 'scale(1) translateY(0)' : 'scale(0.98) translateY(20px)')};
  background-color: ${Color.White};
  box-shadow: 0 10px 70px ${transparentize(0.65, Color.Grey950)};
  pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};
  ${getDefaultTransition('opacity', 'transform')}
`

export const Overlay = styled.div<OverlayProps>`
  display: flex;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${zIndex.ModalOverlay};
  background-color: ${transparentize(0.6, Color.Grey950)};
  pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};
  ${getDefaultTransition('opacity')};
`

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: ${Spacing.S16};
  right: ${Spacing.S24};
  cursor: pointer;
`

export const ModalBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 200px);
  padding: ${Spacing.S16} ${Spacing.S32} ${Spacing.S32};
  position: relative;
  overflow: auto;
`

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  justify-content: flex-end;
  padding: ${Spacing.S16} ${Spacing.S32};
  border-bottom-right-radius: ${DefaultValue.BorderRadius};
  border-bottom-left-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey100};

  button + button: {
    margin-left: ${Spacing.S8};
  }
`

export const ModalHeader = styled.div`
  padding: ${Spacing.S24} ${Spacing.S32} ${Spacing.S16};
  text-overflow: ellipsis;
`
